/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Shipping_N_Delivery__Question_4Inputs */

const en_help_center__shipping_n_delivery__question_4 = /** @type {(inputs: Help_Center__Shipping_N_Delivery__Question_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do products come with warranties?`)
};

/**
* | output |
* | --- |
* | "Do products come with warranties?" |
*
* @param {Help_Center__Shipping_N_Delivery__Question_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__shipping_n_delivery__question_4 = /** @type {((inputs?: Help_Center__Shipping_N_Delivery__Question_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Shipping_N_Delivery__Question_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__shipping_n_delivery__question_4(inputs)
});